import React, { useState, useEffect, useContext } from "react";
import Button from "../../common_components/Button";
import Modal from "../../common_components/Modal";



function ConfirmationModal({ confirmAction, ...props }) {

    return (
        <Modal toggleModal={props.toggleModal} isOpen={props.isOpen} closeable={true} backgroundColor="dark">
            <div className="confirmation-modal-card">
                <div className="confirmation-modal-card-content">
                    <h1 className="confirmation-modal-card-content-title">
                        Cancel interview?
                    </h1>
                    <div className="confirmation-modal-card-content-message">
                        Your session will be canceled and the researcher informed.
                    </div>
                </div>
                <div className="confirmation-modal-card-actions">
                    <Button color="gray" size="medium" onClick={confirmAction} >Yes, cancel</Button>
                    <Button color="primary" size="medium" onClick={props.toggleModal}>No, keep it</Button>
                </div>
            </div>
        </Modal>
    )

}


export default ConfirmationModal;